(ns frontend.actions.decision
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]))

(defn *->create
  [data on-success! on-error!]
  (-> (conn/sendp! :decision/create
                   data
                   120000)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->create-with-response
  [data on-success! on-error!]
  (-> (conn/sendp! :transaction-process/create-decision
                   data
                   120000)
      (p/then (fn [{:keys [body] :as resp}]
                (if (:db/id body)
                  (on-success! resp)
                  (on-error! resp))))
      (p/catch on-error!)))

(defn *->update
  [data on-success! on-error!]
  (-> (conn/sendp! :decision/update
                   data
                   120000)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->update-for-transaction-process
  [{:keys [data on-success on-error]}]
  (-> (conn/sendp! :transaction-process/update-decision
                   data
                   120000)
      (p/then on-success)
      (p/catch on-error)))

(defn *->disable!
  [entity-id on-success! on-error!]
  (-> (conn/sendp! :decision/disable!
                   {:entity-id (or (:db/id entity-id) entity-id)})
      (p/then on-success!)
      (p/catch on-error!)))
